module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joshua Gunn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Joshua Gunn")]), _vm._v(" is associate professor of communication studies at the University of Texas at Austin. He is the author of "), _c('I', [_vm._v("Speech Craft")]), _vm._v("."), _c('br'), _vm._v("  ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rGnntG/tc-custom/9780226713588.jpg?1738725237945",
      "alt": "This image is the cover for the book Political Perversion"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Political Perversion\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When Trump became president, much of the country was repelled by what they saw as the vulgar spectacle of his ascent, a perversion of the highest office in the land. In his bold, innovative book, "), _c('i', [_vm._v("Political Perversion")]), _vm._v(", rhetorician Joshua Gunn argues that this “mean-spirited turn” in American politics (of which Trump is the paragon) is best understood as a structural perversion in our common culture, on a continuum with infantile and “gotcha” forms of entertainment meant to engender provocation and sadistic enjoyment."), _c('br'), _c('br'), _vm._v(" Drawing on insights from critical theory, media ecology, and psychoanalysis, Gunn argues that perverse rhetorics dominate not only the political sphere but also our daily interactions with others, in person and online. From sexting to campaign rhetoric, Gunn advances a new way to interpret our contemporary political context that explains why so many of us have difficulty deciphering the appeal of aberrant public figures. In this book, Trump is only the tip of a sinister, rapidly growing iceberg, one to which we ourselves unwittingly contribute on a daily basis.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0